<div *ngIf="dataSource.data.length > 0">
    <h3>Region {{ lstCourseHistory[0].courseHistory.REGION.CODE }} -{{ lstCourseHistory[0].courseHistory.REGION.NAME }}
    </h3>
</div>

<div class="table-responsive" *ngIf="dataSource.data.length > 0">
    <mat-table [dataSource]="dataSource" *ngIf="!editing">
        <ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchema">
            <mat-header-cell *matHeaderCellDef>
                <h4>{{ col.label }}</h4>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <div [ngSwitch]="col.key">
                    <div *ngSwitchCase="'schoolYear'">
                        <div>{{ element.courseHistory.SCHOOL_YEAR }}</div>
                    </div>
                    <div *ngSwitchCase="'courseTitle'">
                        <div>{{ element.courseHistory?.COURSE_TITLE }}</div>
                    </div>
                    <div *ngSwitchCase="'subjectAreaName'">
                        {{ element.courseHistory?.SUBJECT_TITLE }}
                    </div>
                    <div *ngSwitchCase="'courseType'">
                        {{ element.courseHistory?.COURSE_TYPE?.NAME }}
                    </div>
                    <div *ngSwitchCase="'courseDuration'">
                        {{ element.courseHistory?.COURSE_SECTION?.NAME }}
                    </div>
                    <div *ngSwitchCase="'termType'">
                        {{ element.courseHistory?.TERM_TYPE.NAME }}
                    </div>
                    <div *ngSwitchCase="'daysCompleted'">
                        {{ element.courseHistory?.CLOCK_HOURS }}
                    </div>
                    <div *ngSwitchCase="'gradetoDate'">
                        {{ element.courseHistory?.GRADE_TO_DATE }}
                    </div>
                    <div *ngSwitchCase="'creditsGranted'">
                        {{ element.courseHistory?.CREDITS_GRANTED }}
                    </div>
                    <div *ngSwitchCase="'addedByDate'">
                        <div class="col">
                            <div class="row">
                                {{ element.courseHistory?.CREATED_BY }}
                            </div>
                            <div class="row">
                                {{ element.courseHistory?.CREATED_DATE | simpleDate }}
                            </div>
                        </div>
                    </div>
                </div>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <mat-table [dataSource]="dataSource" *ngIf="editing">
        <ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchemaEdit">
            <mat-header-cell *matHeaderCellDef>
                <h4>{{ col.label }}</h4>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <div *ngIf="element.isEdit == false" [ngSwitch]="col.key">
                    <div *ngSwitchCase="'schoolYear'">
                        <div>{{ element.courseHistory.SCHOOL_YEAR }}</div>
                    </div>
                    <div *ngSwitchCase="'courseTitle'">
                        <div>{{ element.courseHistory?.COURSE_TITLE }}</div>
                    </div>
                    <div *ngSwitchCase="'subjectAreaName'">
                        {{ element.courseHistory?.SUBJECT_TITLE }}
                    </div>
                    <div *ngSwitchCase="'courseType'">
                        {{ element.courseHistory?.COURSE_TYPE?.NAME }}
                    </div>
                    <div *ngSwitchCase="'courseDuration'">
                        {{ element.courseHistory?.COURSE_SECTION?.NAME }}
                    </div>
                    <div *ngSwitchCase="'termType'">
                        {{ element.courseHistory?.TERM_TYPE.NAME }}
                    </div>
                    <div *ngSwitchCase="'daysCompleted'">
                        {{ element.courseHistory?.CLOCK_HOURS }}
                    </div>
                    <div *ngSwitchCase="'gradetoDate'">
                        {{ element.courseHistory?.GRADE_TO_DATE }}
                    </div>
                    <div *ngSwitchCase="'creditsGranted'">
                        {{ element.courseHistory?.CREDITS_GRANTED }}
                    </div>
                    <div *ngSwitchCase="'addedByDate'">
                        <div class="col">
                            <div class="row">{{ element.courseHistory?.CREATED_BY }}</div>
                            <div class="row">
                                {{ element.courseHistory?.CREATED_DATE | simpleDate }}
                            </div>
                        </div>
                    </div>
                    <div *ngSwitchCase="'isEdit'">
                        <button *ngIf="editAccess" mat-icon-button color="primary" (click)="editRow(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button *ngIf="editAccess" mat-icon-button color="warn" (click)="removeCourseHistory(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="element.isEdit == true && editing" [ngSwitch]="col.key">
                    <div *ngSwitchCase="'schoolYear'">
                        <div *ngIf="element.courseHistory.ID < 0">
                            <div>
                                <app-school-year [label]="'School Year'" [yearType]="'SchoolYear'"
                                    [currentYearModifier]="0" [yearsForward]="0" [yearsBack]="2"
                                    [startingSchoolYearDate]="startingSchoolYearDate" [required]="true"
                                    (performancePeriodEvent)="performancePeriodEvent($event, element)"></app-school-year>
                            </div>

                            <div>
                                <mat-form-field class="form-input" appearance="fill">
                                    <mat-label>Enrollment</mat-label>
                                    <mat-select id="selEnrollment" name="selEnrollment"
                                        [(ngModel)]="element.courseHistory.SCHOOL_ENROLLMENT" [compareWith]="compareFn"
                                        required="true" [formControl]="ctrEnrollment">
                                        <mat-option *ngFor="let enrollment of schoolenrollment" [value]="enrollment">
                                            {{ enrollment.SCHOOL_YEAR }} - {{ enrollment.SCHOOL_NAME }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="ctrEnrollment.hasError">Select the School Enrollment</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div *ngIf="element.courseHistory.ID > 0">
                            {{ element.courseHistory.SCHOOL_YEAR }}
                        </div>
                    </div>

                    <div *ngSwitchCase="'courseTitle'">
                        <mat-form-field>
                            <mat-label>Course Title</mat-label>
                            <input matInput [(ngModel)]="element.courseHistory.COURSE_TITLE" required="true"
                                [formControl]="ctrCourseTitle" />
                            <mat-error *ngIf="ctrCourseTitle.hasError">Select the Course Title</mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngSwitchCase="'subjectAreaName'">
                        <mat-form-field>
                            <mat-label>Subject Area Name</mat-label>
                            <input matInput [(ngModel)]="element.courseHistory.SUBJECT_TITLE" required="true"
                                [formControl]="ctrSubjectAreaName" />
                            <mat-error *ngIf="ctrSubjectAreaName.hasError">Select the Subject Area Name</mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngSwitchCase="'courseType'">
                        <mat-form-field class="form-input" appearance="fill">
                            <mat-label>Course Type</mat-label>
                            <mat-select id="selCourseType" name="selCourseType"
                                [(ngModel)]="element.courseHistory.COURSE_TYPE" [compareWith]="compareFn"
                                required="true" [formControl]="ctrCourseType">
                                <mat-option *ngFor="let type of courseTypes" [value]="type">{{ type.CODE }} - {{
                                    type.NAME }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="ctrCourseType.hasError">Select the Course Type</mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngSwitchCase="'courseDuration'">
                        <div>
                            <mat-form-field class="form-input" appearance="fill">
                                <mat-label>Course Duration</mat-label>
                                <mat-select id="selCourseDuration" name="selCourseDuration"
                                    [(ngModel)]="element.courseHistory.COURSE_SECTION" [compareWith]="compareFn">
                                    <mat-option value=""></mat-option>
                                    <mat-option *ngFor="let section of courseSections" [value]="section">{{ section.CODE
                                        }} - {{ section.NAME }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div *ngSwitchCase="'termType'">
                        <mat-form-field class="form-input" appearance="fill">
                            <mat-label>Term Type</mat-label>
                            <mat-select id="selTermType" name="selTermType"
                                [(ngModel)]="element.courseHistory.TERM_TYPE" [compareWith]="compareFn" required="true"
                                [formControl]="ctrTermType">
                                <mat-option *ngFor="let type of termTypes" [value]="type">{{ type.CODE }} - {{ type.NAME
                                    }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="ctrTermType.hasError">Please select the Term Type</mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngSwitchCase="'daysCompleted'">
                        <mat-form-field>
                            <mat-label>Days Completed</mat-label>
                            <input matInput type="number" min="0" max="999" maxlength="3"
                                [(ngModel)]="element.courseHistory.CLOCK_HOURS" required="true"
                                [formControl]="ctrDaysCompleted" />

                            <mat-error *ngIf="ctrDaysCompleted.hasError('required')">Enter value between 1 to
                                100</mat-error>
                            <mat-error *ngIf="ctrDaysCompleted.hasError('min')">The value is lesser than 0</mat-error>
                            <mat-error *ngIf="ctrDaysCompleted.hasError('max')">The value is greater than
                                100</mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngSwitchCase="'gradetoDate'">
                        <mat-form-field>
                            <mat-label>Grade to Date</mat-label>
                            <input matInput type="number" min="0" max="999" maxlength="3"
                                [(ngModel)]="element.courseHistory.GRADE_TO_DATE" [formControl]="ctrGradetoDate" />
                            <mat-error *ngIf="ctrGradetoDate.hasError('min')">The value is lesser than 0</mat-error>
                            <mat-error *ngIf="ctrGradetoDate.hasError('max')">The value is greater than 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngSwitchCase="'creditsGranted'">
                        <mat-form-field>
                            <mat-label>Credits Granted</mat-label>
                            <input matInput type="number" min="0" max="1"
                                [(ngModel)]="element.courseHistory.CREDITS_GRANTED" [formControl]="ctrCreditsGranted" />
                            <mat-error *ngIf="ctrCreditsGranted.hasError('min')">The value is lesser than 0</mat-error>
                            <mat-error *ngIf="ctrCreditsGranted.hasError('max')">The value is greater than 1</mat-error>
                        </mat-form-field>
                    </div>

                    <div *ngSwitchCase="'addedByDate'">
                        <div class="col">
                            <div class="row">{{ element.courseHistory?.CREATED_BY }}</div>
                            <div class="row">
                                {{ element.courseHistory?.CREATED_DATE | simpleDate }}
                            </div>
                        </div>
                    </div>

                    <div *ngSwitchCase="'isEdit'">
                        <mat-icon *ngIf="isSaving">
                            <mat-spinner *ngIf="isSaving" diameter="20"></mat-spinner>
                        </mat-icon>

                        <div *ngIf="element.isDelete == false && isSaving == false">
                            <button mat-icon-button color="primary" (click)="updateRow(element)"
                                [disabled]="disableSubmit(element)">
                                <mat-icon>done</mat-icon>
                            </button>
                            <button mat-icon-button (click)="cancelRow(element)">
                                <mat-icon class="icon-display">cancel</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="element.isDelete == true && isSaving == false">

                            <button mat-icon-button color="primary" (click)="deleteRow(element)">
                                <mat-icon>delete_forever</mat-icon>
                            </button>
                            <button mat-icon-button (click)="cancelRow(element)">
                                <mat-icon class="icon-display">cancel</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumnsEdit"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumnsEdit"></mat-row>
    </mat-table>
    <mat-paginator [length]="dataSource.data.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
        aria-label="Select page of periodic elements"></mat-paginator>
</div>